import React, { createContext, useContext, useState, useEffect, } from 'react';
const ShiftKeyContext = createContext(false);
export const useIsShiftPressed = () => useContext(ShiftKeyContext);
export const ShiftKeyProvider = ({ children }) => {
    const [isShiftPressed, setIsShiftPressed] = useState(false);
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Shift') {
                setIsShiftPressed(true);
            }
        };
        const handleKeyUp = (event) => {
            if (event.key === 'Shift') {
                setIsShiftPressed(false);
            }
        };
        const handleBlur = () => setIsShiftPressed(false);
        if (typeof window !== 'undefined') {
            window.addEventListener('keydown', handleKeyDown);
            window.addEventListener('keyup', handleKeyUp);
            window.addEventListener('blur', handleBlur);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('keydown', handleKeyDown);
                window.removeEventListener('keyup', handleKeyUp);
                window.removeEventListener('blur', handleBlur);
            }
        };
    }, []);
    return (<ShiftKeyContext.Provider value={isShiftPressed}>
      {children}
    </ShiftKeyContext.Provider>);
};
